import { createAsyncThunk } from '@reduxjs/toolkit';
import type PreFillApi from 'api/digifi/application/PreFillApi';
import { ActionType } from 'enums/ActionType';

export const createGetPreFillExperianDataThunk = (api: PreFillApi) => {
  return createAsyncThunk(
    ActionType.FetchPreFillExperianData,
    async (data: { externalId: string }) => {
      return await api.getPreFillExperianData(data.externalId);
    },
  );
};
